import { Component, OnDestroy, OnInit } from '@angular/core';
import { NoDataActionType } from '../../../../../shared/interfaces/no-data';
import { CustomDashboardsService } from '../../../../services/my-limegear.service';
import { ICardInfo } from '../../interfaces/stanalone-components.data';
import { SmallCardService } from '../../services/small-card.service';

@Component({
    selector: 'submit-uw-smallcard',
    templateUrl: './submit-uw-smc.component.html',
    styleUrls: ['./submit-uw-smc.component.scss'],
})
export class SubmitUwSmallcardComponent implements OnInit, OnDestroy {
    constructor(
        private _customDashboardsService: CustomDashboardsService,
        private _smallCardService: SmallCardService
    ) {}

    cardInfo: ICardInfo;
    ngOnInit() {
        this.cardInfo = {
            index: 1,
            cardId: 'submit-uw',
            milestoneKey: 8,
            title: 'Submit UW',
            property_1: 'nbr',
        };
        let action: NoDataActionType = NoDataActionType.pageStart;
        let cardDrilldownUrl: string = '/reporting/pipeline';

        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this.cardInfo.card = this._smallCardService.initializeSmallCard(this.cardInfo, action);
            this._smallCardService.getPipelineSmallCardData(
                changes.displayOptions,
                changes.hierarchyfilters,
                this.cardInfo,
                changes.action,
                cardDrilldownUrl
            );
        });
    }

    ngOnDestroy() {}
}
